const convertDecimalAfterComma = (value: number, long: number) => {
  return value % 1 === 0 ? value : value.toFixed(long);
};
export default convertDecimalAfterComma;
